module.exports = __webpack_public_path__ + "img/BrandyTorres15anos.67494875.jpg";